'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { useIsTablet } from '@/hooks/use-tablet';
import { isFocusableFormField } from '@/hooks/use-tablet-keyboard-guard';

function blurActiveFormField() {
  const active = document.activeElement;
  if (isFocusableFormField(active)) {
    active.blur();
  }
}

/** Blur stray focused inputs on tablet after navigation / initial paint. */
export function TabletFocusGuard() {
  const isTablet = useIsTablet();
  const pathname = usePathname();

  useEffect(() => {
    if (!isTablet) return;
    const id = requestAnimationFrame(blurActiveFormField);
    return () => cancelAnimationFrame(id);
  }, [isTablet]);

  useEffect(() => {
    if (!isTablet) return;
    blurActiveFormField();
  }, [pathname, isTablet]);

  return null;
}
